import type { Action } from 'vuex'
import type { State, UploadProgressStatus, UploadResultCount } from './state'

import actionTypes from './actionTypes'
import { UploadBulkFiles } from '@/api/bulkFileUpload/model/bulkFileUploadModel'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_MODAL_BULK_FILE_UPLOAD_ACTIVED]: (
    { commit },
    status: boolean
  ): void => {
    commit(actionTypes.SET_MODAL_BULK_FILE_UPLOAD_ACTIVED, status)
  },

  [actionTypes.SET_MODAL_DISCONTINUE_UPLOAD_ACTIVED]: (
    { commit },
    status: boolean
  ): void => {
    commit(actionTypes.SET_MODAL_DISCONTINUE_UPLOAD_ACTIVED, status)
  },

  [actionTypes.SET_UPLOAD_PROGRESS_STATUS]: (
    { commit },
    status: UploadProgressStatus
  ): void => {
    commit(actionTypes.SET_UPLOAD_PROGRESS_STATUS, status)
  },

  [actionTypes.SET_TOTAL_COUNT]: (
    { commit },
    totalCount: number
  ): void => {
    commit(actionTypes.SET_TOTAL_COUNT, totalCount)
  },

  [actionTypes.SET_CURRENT_COUNT]: (
    { commit },
    currentCount: number
  ): void => {
    commit(actionTypes.SET_CURRENT_COUNT, currentCount)
  },

  [actionTypes.SET_UPLOAD_RESULT_COUNT]: (
    { commit },
    uploadResultCount: UploadResultCount
  ): void => {
    commit(actionTypes.SET_UPLOAD_RESULT_COUNT, uploadResultCount)
  },

  [actionTypes.SET_FILE_CHECK_ERROR]: (
    { commit },
    errorMessage: string
  ): void => {
    commit(actionTypes.SET_FILE_CHECK_ERROR, errorMessage)
  },

  [actionTypes.SET_UPLOAD_FILES]: (
    { commit },
    uploadFiles: UploadBulkFiles
  ): void => {
    commit(actionTypes.SET_UPLOAD_FILES, uploadFiles)
  },
}

export default actions
